export const gold = "#C6A664";
export const logoblue = "#1a3062";
